import { render, staticRenderFns } from "./I2FormInputMoney.vue?vue&type=template&id=27a09aa7"
import script from "./I2FormInputMoney.vue?vue&type=script&lang=js"
export * from "./I2FormInputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports